// extracted by mini-css-extract-plugin
module.exports = {"referralHistory":"ReferralHistory_referralHistory___ZGh2","container":"ReferralHistory_container__q42cn","linkWrapper":"ReferralHistory_linkWrapper__NhnZC"};